"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionConfirm = /** @class */ (function (_super) {
    __extends(TableActionConfirm, _super);
    function TableActionConfirm(props) {
        return _super.call(this, props) || this;
    }
    TableActionConfirm.prototype.buttonClick = function () {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    TableActionConfirm.prototype.getButton = function () {
        if (this.props.nocircleicons) {
            return (React.createElement(antd_1.Button, { size: "small", icon: "check", ghost: true, type: "primary", style: { marginLeft: "1px", marginRight: "1px" } }));
        }
        else {
            return (React.createElement(antd_1.Button, { shape: "circle", size: "small", icon: "check", ghost: true, type: "primary", style: { marginLeft: "1px", marginRight: "1px" } }));
        }
    };
    TableActionConfirm.prototype.render = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
            React.createElement(antd_1.Popconfirm, { placement: "left", title: this.props.confirmText, okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442", onConfirm: this.buttonClick.bind(this) }, this.getButton())));
    };
    return TableActionConfirm;
}(React.Component));
exports.default = TableActionConfirm;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/table_actions/TableActionConfirm.tsx
// module id = 158
// module chunks = 0